import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Encashment History", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Encashment"),
    /*#__PURE__*/_createVNode("th", null, "Recipient"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Amount"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-4" }, "Source")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("td", {
  colspan: "4",
  class: "text-center text-muted py-10"
}, "No encashment history found.", -1)
const _hoisted_11 = { class: "ps-4" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_14 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_15 = { class: "fw-semibold text-gray-800" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("EC Wallet Top-Up")
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = { class: "fw-semibold text-gray-800" }
const _hoisted_19 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "fw-semibold text-gray-800" }
const _hoisted_22 = { class: "text-muted fs-8" }
const _hoisted_23 = { class: "text-end pe-4" }
const _hoisted_24 = {
  key: 0,
  class: "seq-badge seq-badge--success"
}
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Money.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("table", _hoisted_7, [
            _hoisted_8,
            _createVNode("tbody", null, [
              (_ctx.list.length === 0)
                ? (_openBlock(), _createBlock("tr", _hoisted_9, [
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("span", _hoisted_13, [
                        _createVNode("span", _hoisted_14, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Up-2.svg" })
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_15, [
                          (item.destination == 'Bank' || item.destination == 'Cash' || item.destination == 'IBayad' || item.destination == 'Chinatrust')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(item.destination), 1)
                              ], 64))
                            : (item.destination == 'W')
                              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  _hoisted_16
                                ], 64))
                              : (item.chequereleasebranch != null && item.chequereleasebranch != '')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(item.destination) + " / " + _toDisplayString(item.chequereleasebranch), 1)
                                  ], 64))
                                : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(item.destination), 1)
                                  ], 64))
                        ]),
                        _createVNode("div", _hoisted_17, "Ref #" + _toDisplayString(item.id) + " · " + _toDisplayString(item.txndte), 1)
                      ])
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_18, _toDisplayString(item.fullname), 1),
                    (item.accountno)
                      ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(item.accountno), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_20, [
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.numberWithCommas(item.net.toFixed(2))) + " " + _toDisplayString(item.ccy3), 1),
                    _createVNode("div", _hoisted_22, "Gross " + _toDisplayString(_ctx.numberWithCommas(item.gross.toFixed(2))), 1)
                  ]),
                  _createVNode("td", _hoisted_23, [
                    (item.encashFrom == 'DRC')
                      ? (_openBlock(), _createBlock("span", _hoisted_24, "Direct Sales"))
                      : (_openBlock(), _createBlock("span", _hoisted_25, "—"))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}